module.exports = __webpack_public_path__ + "static/img/13.5fc87fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/13.png
// module id = NOgB
// module chunks = 4